






















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { PlanRecordButton, PlanEditButton, PlanCancelButton, TermOfValidityTag } from '@/components/plan';

import { CourseChangeButton } from '@/components/course';

import { Plan } from '@/domains/work';

@Component({
  name: 'PlanUserTable',
  components: {
    TermOfValidityTag,
    PlanEditButton,
    PlanCancelButton,
    PlanRecordButton,
    CourseChangeButton,
  },
})
export default class PlanUserTable extends Vue {
  /** bus */
  @Prop()
  private bus: Vue;

  /** 计划列表 */
  @Prop()
  private plans: Plan[];

  /** 数据列表 */
  private datas: Plan[] = [];

  get selections(): Plan[] { return this.plans; }

  set selections(value: Plan[]) { this.$emit('update:plans', value); }

  private selectionChange(value: Plan[]) {
    this.selections = value;
  }

  private mounted() {
    this.bus.$on('plan-user-table', (datas: Plan[]) => { this.datas = datas; });
  }
}
